import { Card, CardContent, Typography } from "@altimateai/lego";
import styles from "./styles.module.scss";
import classnames from "classnames";

const ListSummary = ({
  summary,
}: {
  summary: { label: string; value: number; info?: string; color?: string }[];
}) => {
  summary[0].color = styles.blue;
  summary[1].color = styles.orange;
  summary[2].color = styles.yellow;
  summary[3].color = styles.green;
  summary[4].color = styles.pink;
  return (
    <Card>
      <CardContent className="p-0">
        <div className={styles.container}>
          {summary.map(item => (
            <div key={item.label} className={styles.item}>
              <div className={classnames(styles.border, item.color)} />
              <div className="pt-2 pb-2">
                <Typography
                  variant="body"
                  size="xs"
                  weight="medium"
                  className="al-text-gray-600 !al-text-sm"
                >
                  {item.label}
                </Typography>
                <Typography variant="h3" weight="semibold" className="al-text-gray-900">
                  {item.value}
                </Typography>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default ListSummary;
